<div *ngIf="showLoading" class="flexCenter">
    <mat-spinner></mat-spinner>
</div>

<div [hidden]="showLoading">

    <app-formular [formBuilderInput]="childFormInput" [formular]="formular" (action)="action($event)"
        (date)="dateChange($event)"></app-formular>
    <button mat-raised-button matStepperNext>{{"Next" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
</div>